<template>
    <div style="margin:0 10px">
        <router-view></router-view>
        <div class="card" v-if="$route.name === 'course'">
            <!-- search -->
            <div class="search d-flex a-center">
                <div style="width:160px;margin-right:10px;">
                    <el-input type="text" v-model="query.name" placeholder="请输入课程名称" class="search-input"></el-input>  
                </div>
                <div style="width:160px;margin-right:10px;">
                    <el-input type="text" v-model="query.code" placeholder="请输入课程代码" class="search-input"></el-input>  
                </div>
                <el-button class="search-button" @click="init"></el-button>
                <el-button class="add-button" @click="$router.push({name:'course_add'})"></el-button>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                    element-loading-background="rgba(255,255,255, 0.6)"
                >
                    <el-table-column prop="code" label="课程代码" align="center" width="180"></el-table-column>
                    <el-table-column prop="name" label="课程名称" align="center"></el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="620">
                        <template slot-scope="scope">
                            <el-button @click="$router.push({name:'course_add',query:{id:scope.row.id}})" type="text" size="small" class="edit-action">编辑</el-button>
                            <el-popconfirm
                                style="margin-left: 10px;"
                                title="是否确定删除？"
                                @confirm="handleDel(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small" class="delete-action">删除</el-button>
                            </el-popconfirm>
                            <el-button @click="$router.push({name:'course_chapter',query:{courseId:scope.row.id,courseName:scope.row.name}})" type="text" size="small" style="margin-left:10px;color:#67C23A;">章节结构</el-button>
                            <el-button @click="openKnowledgeGraph(scope.row)" type="text" size="small" style="margin-left:10px;color:#E6A23C;">知识图谱</el-button>
                            <el-button @click="handleAiGenerateNodes(scope.row)" type="text" size="small" style="margin-left:10px;color:#409EFF;">AI生成知识点</el-button>
                            <el-button @click="handleAiGenerateEdges(scope.row)" type="text" size="small" style="margin-left:10px;color:#409EFF;">AI生成关系</el-button>
                            <el-popconfirm
                                style="margin-left: 10px;"
                                title="确定清除当前课程所有知识点和关系？此操作不可恢复！"
                                @confirm="handleAiClearGraph(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small" style="color:#F56C6C;">清除图谱</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- page -->
                <div style="margin-top:20px;text-align:center">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :total="total"
                        :page-sizes="pageSizes"
                        :page-size="query.size"
                        @size-change="onSize"
                        @current-change="onCurrPage"
                        @prev-click="onCurrPage"
                        @next-click="onCurrPage"
                    >
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { lists, del } from '@/request/api/course.js'
import { aiGenerateNodes, aiGenerateEdges, aiClearGraph } from '@/request/api/knowledge_graph.js'
export default {
    data() {
        return {
            tableData: [],
            query: { name: '', code: '', page: 1, size: 10 },
            pageSizes: [10, 30, 50, 100],
            total: 0,
            loading: false,
        }
    },
    watch: {
        $route(val, old) {
            if (val.name == 'course') {
                this.init()
            }
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.loading = true
            lists(this.query).then(res => {
                this.tableData = res.data.list || []
                this.total = res.data.total || 0
            }).finally(() => {
                this.loading = false
            })
        },
        handleDel(data) {
            del(data.id).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                this.init()
                this.$notify({ title: '成功', message: res.msg, type: 'success' })
            })
        },
        onSize(val) {
            this.query.size = val
            this.init()
        },
        onCurrPage(val) {
            this.query.page = val
            this.init()
        },
        openKnowledgeGraph(row) {
            // 弹出完全独立的知识图谱页面（无菜单框架）
            const routeUrl = this.$router.resolve({
                name: 'course_knowledge_graph_standalone',
                query: {
                    courseId: row.id,
                    courseName: row.name
                }
            })
            window.open(routeUrl.href, '_blank')
        },
        // AI生成知识点
        handleAiGenerateNodes(row) {
            this.$confirm('确认使用AI生成知识点？这可能需要几分钟时间。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                aiGenerateNodes({ courseId: row.id }).then(res => {
                    if (res.code == 0) {
                        this.$alert('操作成功，请10分钟后再查看生成结果', '提示', {
                            confirmButtonText: '确定',
                        })
                    } else {
                        this.$notify.error({ title: '错误', message: res.msg || '操作失败' })
                    }
                })
            }).catch(() => {})
        },
        // AI生成知识点关系
        handleAiGenerateEdges(row) {
            this.$confirm('确认使用AI生成知识点关系？这可能需要几分钟时间。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                aiGenerateEdges({ courseId: row.id }).then(res => {
                    if (res.code == 0) {
                        this.$alert('操作成功，请10分钟后再查看生成结果', '提示', {
                            confirmButtonText: '确定',
                        })
                    } else {
                        this.$notify.error({ title: '错误', message: res.msg || '操作失败' })
                    }
                })
            }).catch(() => {})
        },
        // 清除图谱
        handleAiClearGraph(row) {
            aiClearGraph({ courseId: row.id }).then(res => {
                if (res.code == 0) {
                    this.$notify({ title: '成功', message: '图谱内容已清除', type: 'success' })
                } else {
                    this.$notify.error({ title: '错误', message: res.msg || '操作失败' })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.card {
    border-radius: 4px;
    padding: 20px;
}
</style>
